import { createReducer, FAILURE, SUCCESS, updateObject } from 'Stores'
import { GENERATE_CODE, VERIFY_CODE, VERIFY_CODE_RESET } from './constants'

export const initialState = {
  qrCode: '',
  verify: false
}

function generateCode(state, { payload }) {
  const { qrCode } = payload
  return updateObject(state, {
    qrCode
  })
}

function verifyCodeResetSuccess(state, { payload }) {
  const { qrCode } = payload
  return updateObject(state, {
    qrCode
  })
}

function verifyCodeResetFail(state) {
  return updateObject(state, {
    qrCode: ''
  })
}
function verifyCodeSuccess(state) {
  return updateObject(state, {
    verify: true
  })
}

function verifyCodeFail(state) {
  return updateObject(state, {
    verify: false
  })
}

export default createReducer(initialState, {
  [SUCCESS(GENERATE_CODE)]: generateCode,
  [SUCCESS(VERIFY_CODE_RESET)]: verifyCodeResetSuccess,
  [FAILURE(VERIFY_CODE_RESET)]: verifyCodeResetFail,
  [SUCCESS(VERIFY_CODE)]: verifyCodeSuccess,
  [FAILURE(VERIFY_CODE)]: verifyCodeFail
})
